<template>
  <div>
    <div style="width: 100%;height: 50px;"></div>
    <!-- <div class="container text-center xxx" style="display: flex;justify-content: center;">
      <p>&copy; {{ currentYear }} {{ companyName }}</p>
      <p>{{ address }}</p>
      <p>{{ email }}</p>
      <p>{{ recordNumber }}</p>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        currentYear: new Date().getFullYear(),
        companyName: 'Your Company',
        address: '123 Street, City, Country',
        email: 'info@yourcompany.com',
        recordNumber: '备案号xxxxxx'
      };
    }
  };
</script>

<style scoped>
  /* 在这里可以添加一些特定的样式，例如修改文字颜色、背景色等 */
  .xxx {
    position: fixed;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue